import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app';
// import { NzNotificationService, NzMessageService } from 'ng-zorro-antd';

@Component({
  selector: 'app-api-dashboard',
  templateUrl: './api-dashboard.component.html',
  styleUrls: ['./api-dashboard.component.scss']
})
export class ApiDashboardComponent implements OnInit {

  apiForm!: FormGroup;
  // Lookup for below APIs: paCreateSimulateCd
  // apiList: Array<{ [key: string]: string }> = [
  //   // { apiUrl: "claim/preauth/portal/save", apiLabel: "Customer CheckIn Save" },
  //   // {apiUrl:"/claim/preauth/save",apiLabel: "Esubmission Save" },
  //   {apiUrl:"claim/preauth/create",apiLabel: "Interface Creation" }   
  // ]
  argumentValue: string;

  constructor(private fb: FormBuilder,
    private apiRequestService: ApiRequestService,
    private commonUtilty: CommonUtilty,
    private lookupDataService: LookupDataService,
    // private message: NzMessageService
  ) { }

  apiLookupDataList = [];
  ngOnInit() {
    this.apiForm = this.fb.group({
      api: [null, [Validators.required]]
      // argument: [null]
    });

    this.lookupDataService.getLookup('apiDashboardCd').subscribe(res => {
      this.apiLookupDataList = res;
    });
  }

  responseRec : boolean = false;
  apiResult: any;
  submitForm(): void {
    for (const i in this.apiForm.controls) {
      this.apiForm.controls[i].markAsDirty();
      this.apiForm.controls[i].updateValueAndValidity();
    }
    let requestBody = null;
    try{
      if(this.argumentValue && this.apiForm.get('api').value !== 'claimBatchUpdateDate'){
        requestBody = JSON.parse(this.argumentValue)
      }
      else if(this.argumentValue && this.apiForm.get('api').value === 'claimBatchUpdateDate'){
        requestBody = this.argumentValue;
      }
    }
    catch{
      console.warn("Incorrect Preauth JSON submission, the request body must be JSON object. Please recheck for additional quotes or the key value pair of the object");
    }
    this.apiRequestService.get(this.apiForm.controls.api.value).subscribe(val => {
      this.apiResult = JSON.stringify(val);
      this.responseRec = true;
      if(val)
      this.getIntimationNum(val)
    }
    )
  }

  parseJson() : any {
      // this.apiResult = this.removeEmpty(this.commonUtilty.deepCopy(this.apiResult));
    this.argumentValue = JSON.stringify(this.removeEmpty(this.commonUtilty.deepCopy(JSON.parse(this.argumentValue))));
  }

  removeEmpty(obj) {
    return Object.entries(obj)
      .filter(([_, v]) => v != null)
      .reduce(
        (acc, [k, v]) => ({ ...acc, [k]: v === Object(v) ? this.removeEmpty(v) : v }),
        {}
      );
  }

  transformJson(source){
    if(source === 'INPUT'){
      var obj = JSON.parse(this.argumentValue);
      var pretty = JSON.stringify(obj, undefined, 4);
      this.argumentValue = this.commonUtilty.deepCopy(pretty)
    }
    if(source === 'OUTPUT'){
      var obj = JSON.parse(this.apiResult);
      var pretty = JSON.stringify(obj, undefined, 4);
      this.apiResult = this.commonUtilty.deepCopy(pretty)
    }
  }

  fetchMail(){
    this.apiRequestService.getCallWithAPIMapper("fetchMails").subscribe(res=>{
      if(res)
      {
        
      }
    })
  }
  APIRequestLookup = [
    {
        "lookupKey": "proposal/fetchMails",
        "lookupValue": "Fetch Master Report",
        "sortOrder": 1,
        "criteriaLookupKey": null,
        "displayFl": null,
        "workflowStatusCd": "PUBLISH",
        "lookupAddValue1": null,
        "lookupAddValue2": null,
        "defaultFl": null
    }
]
  dummyRequestBody = {
    "criteriaIOs": [
      {
        "key": "fromPeriod",
        "value": "01-02-2023"
      },
      {
        "key": "toPeriod",
        "value": "28-02-2023"
      }
    ],
    "reportName": "CLAIM_MASTER_DATA"
  }

  body = {
    "exceptionDOList": [],
    "contextDOList": null,
    "globalContextsRulesMap": null,
    "clientDOs": [
      {
        "parentObject": null,
        "versionId": 3220,
        "createdDt": 1594867744463,
        "updatedDt": 1635254566373,
        "createdUser": "AdminScript",
        "updatedUser": "changt",
        "baseCompanyCd": "MMS",
        "versionNum": null,
        "workflowStatusCd": null,
        "shareByRegionalOfc": null,
        "fieldKey": null,
        "fieldValue": null,
        "id": 61439,
        "externalClientNum": "C00100",
        "clientTypeCd": "PERSON",
        "clientNum": "C00100",
        "deDupStatusCd": null,
        "statusCd": null,
        "duplicateFl": null,
        "blackListedFl": null,
        "blackListedReasonCd": null,
        "duplicateClientNum": null,
        "fromEffectiveDT": null,
        "lastEffectiveDt": null,
        "politicalFl": null,
        "modifiedFl": null,
        "cibilScore": 350,
        "organisationDO": null,
        "personDO": {
          "parentObject": null,
          "versionId": 1,
          "guid": "da1bed12-9ada-483b-b514-5307ce312d82",
          "createdDt": 1594867751793,
          "updatedDt": 1614684791290,
          "createdUser": "AdminScript",
          "updatedUser": "kewal@metamorphtech.com",
          "baseCompanyCd": "MMS",
          "versionNum": null,
          "workflowStatusCd": null,
          "shareByRegionalOfc": null,
          "id": 61367,
          "titleCd": null,
          "firstName": "Elon",
          "middleName": null,
          "lastName": "Musk",
          "firstName1": null,
          "middleName1": null,
          "lastName1": null,
          "genderCd": "MALE",
          "dateOfBirth": 178999200000,
          "age": null,
          "maritalStatusCd": null,
          "mothersMaidenName": null,
          "fathersName": null,
          "givenName": null,
          "legalName": null,
          "otherName": null,
          "countryOfBirthCd": "Vietnam",
          "citizenshipCd": "Vietnam",
          "politicalFlag": null,
          "convictedFlag": null,
          "sourceOfIncomeCd": null,
          "fromEffectiveDT": null,
          "lastEffectiveDt": null,
          "personEmploymentList": [],
          "personIdentityList": [
            {
              "parentObject": null,
              "versionId": null,
              "guid": null,
              "createdDt": null,
              "updatedDt": null,
              "createdUser": null,
              "updatedUser": null,
              "baseCompanyCd": "MMS",
              "versionNum": null,
              "workflowStatusCd": null,
              "shareByRegionalOfc": null,
              "id": 30300,
              "identityTypeCd": "PASSPORT",
              "identityNum": "ASOJKJ232",
              "fromEffectiveDT": null,
              "lastEffectiveDt": null,
              "placeOfIssue": null,
              "issueDt": null,
              "objectName": "PersonIdentityDO",
              "referenceNum": null,
              "baseAdditionalFields": null
            }
          ],
          "personEducationList": [
            {
              "parentObject": null,
              "versionId": null,
              "guid": "bb247760-6da1-4ed2-88f1-f4cf0c5e4d2d",
              "createdDt": 1604545793759,
              "updatedDt": 1614684791291,
              "createdUser": "Branch_User",
              "updatedUser": "kewal@metamorphtech.com",
              "baseCompanyCd": "MMS",
              "versionNum": null,
              "workflowStatusCd": null,
              "shareByRegionalOfc": null,
              "id": 24,
              "courseCd": "01",
              "courseCertNum": null,
              "educationTypeCd": null,
              "startDt": null,
              "endDt": null,
              "statusCd": null,
              "durationHrs": null,
              "durationYrs": null,
              "graduationStatusCd": null,
              "objectName": "PersonEducationDO",
              "referenceNum": null,
              "baseAdditionalFields": null
            }
          ],
          "personAdditionalFieldDOs": [],
          "name": "Elon Musk",
          "objectName": "PersonDO",
          "referenceNum": null,
          "baseAdditionalFields": null
        },
        "clientAddressList": [
          {
            "parentObject": null,
            "versionId": 1,
            "guid": "10b3ab46-e730-4d4b-b81c-bcc5e004806e",
            "createdDt": 1594867754607,
            "updatedDt": 1614684791293,
            "createdUser": "AdminScript",
            "updatedUser": "kewal@metamorphtech.com",
            "baseCompanyCd": "MMS",
            "versionNum": null,
            "workflowStatusCd": null,
            "shareByRegionalOfc": null,
            "id": 51114,
            "clientAddressID": null,
            "typeCd": "RESIDENCE",
            "subTypeCd": null,
            "addressLine1": "MIPEC Tower,?229 Tay Son, Nga Tu So, Dong Da, Hanoi, Vietnam",
            "addressLine2": null,
            "addressLine3": null,
            "addressLine4": null,
            "areaCd": null,
            "cityCd": null,
            "talukaCd": null,
            "villageCd": null,
            "stateCd": null,
            "countryCd": null,
            "postCode": null,
            "prefferedFl": true,
            "fromEffectiveDT": null,
            "lastEffectiveDt": null,
            "wardCd": null,
            "districtCd": null,
            "sameAsContactAddressFl": null,
            "objectName": "ClientAddressDO",
            "referenceNum": null,
            "baseAdditionalFields": null
          }
        ],
        "clientContactDetailsList": [
          {
            "parentObject": null,
            "versionId": 1,
            "guid": "4dfb1291-587b-435a-a8e5-5b88aa888113",
            "createdDt": 1594867761703,
            "updatedDt": 1614684791293,
            "createdUser": "AdminScript",
            "updatedUser": "kewal@metamorphtech.com",
            "baseCompanyCd": "MMS",
            "versionNum": null,
            "workflowStatusCd": null,
            "shareByRegionalOfc": null,
            "id": 61223,
            "typeCd": "BUSINESS",
            "subTypeCd": null,
            "contactNum": "+918058725686",
            "extensionNum": null,
            "prefferedFl": true,
            "fromEffectiveDT": null,
            "lastEffectiveDt": null,
            "objectName": "ClientPhoneDO",
            "isd": null,
            "std": null,
            "referenceNum": null,
            "baseAdditionalFields": null
          }
        ],
        "clientEmailList": [
          {
            "parentObject": null,
            "versionId": 1,
            "guid": "f2b9a65f-a72b-4683-9419-f8bd03e27eda",
            "createdDt": 1594867758360,
            "updatedDt": 1614684791293,
            "createdUser": "AdminScript",
            "updatedUser": "kewal@metamorphtech.com",
            "baseCompanyCd": "MMS",
            "versionNum": null,
            "workflowStatusCd": null,
            "shareByRegionalOfc": null,
            "id": 61121,
            "typeCd": "BUSINESS",
            "emailId": "gauravs@metamorphtech.com",
            "prefferedFl": true,
            "fromEffectiveDT": null,
            "lastEffectiveDt": null,
            "objectName": "ClientEmailDO",
            "referenceNum": null,
            "baseAdditionalFields": null
          }
        ],
        "clientAdditionalFieldDOs": [],
        "clientRelationshipDOs": [],
        "name": "Elon Musk",
        "state": "",
        "objectName": "ClientDO",
        "preferredAddress": "MIPEC Tower,?229 Tay Son, Nga Tu So, Dong Da, Hanoi, Vietnam,",
        "preferredMobileNum": "+918058725686",
        "preferredEmail": "gauravs@metamorphtech.com",
        "dateOfBirth": " 03/09/1975",
        "genderCd": "MALE",
        "occupationCd": null,
        "postCode": "",
        "fatherName": "",
        "income": 0,
        "city": "",
        "nameWithSalutation": " Elon Musk",
        "referenceNum": null,
        "baseAdditionalFields": null,
        "guid": "2FCBE256-3CF6-4A0E-A3BE-BCDE7F74E030"
      }
    ],
    "requirementDOs": [],
    "questionnaires": [],
    "correspondences": [],
    "checkLists": [],
    "notes": [],
    "vehicleDOs": null,
    "propertyDOs": null,
    "agentDOs": null,
    "entityDocumentDOs": null,
    "preauthorizationDO": {
      "parentObject": null,
      "versionId": null,
      "versionNum": null,
      "workflowStatusCd": null,
      "shareByRegionalOfc": null,
      "exceptionDOList": null,
      "statusReasonCd": null,
      "statusReasonDesc": null,
      "premiumStatusCd": "PAID",
      "sourceStage": null,
      "targetStage": null,
      "eventDt": "2021-10-21T18:30:00.000Z",
      "ruleEffectiveDate": null,
      "eventTm": [
        17,
        25,
        26
      ],
      "clmIntimationNum": null,
      "submissionModeCd": "PORTAL",
      "entryDt": "2021-10-22T18:30:00.000Z",
      "receivedDt": null,
      "receivedTm": null,
      "intimationDt": "2021-10-22T18:30:00.000Z",
      "intimationSourceCd": null,
      "categoryCd": null,
      "intimationTm": [
        17,
        25,
        26
      ],
      "navDt": null,
      "externalClaimNum": null,
      "propensityScore": null,
      "registrationDt": null,
      "adjudicationDt": null,
      "boundaryFl": null,
      "autoAdjDecisionCd": null,
      "adjDecisionSubCd": null,
      "adjudicationLevel": null,
      "totAdjudicationLevels": null,
      "eventSubTypeCd": null,
      "countryOfEventCd": null,
      "placeOfEventCd": null,
      "wopFl": null,
      "adjReasonNotes": null,
      "adjRemarks": null,
      "adj2Remarks": null,
      "eventEndDt": null,
      "preHospitalizationFl": null,
      "postHospitalizationFl": null,
      "preHospitalizationConsultationDt": null,
      "postHospitalizationConsultationDt": null,
      "isCashless": null,
      "riskAlertCSV": null,
      "claimDecisionCd": null,
      "claimedCurrencyCd": null,
      "taggedClaimNum": null,
      "arrivalToOutsideDt": null,
      "companionAccomodationFl": null,
      "dischargeSummaryFl": null,
      "payoutStatusCd": null,
      "beginDt": null,
      "tpaId": null,
      "claimedAmt": null,
      "approvedAmt": null,
      "disapproveAmt": null,
      "deductibleAmt": 20,
      "coPayAmt": null,
      "deductiblePercentage": null,
      "roomFactor": null,
      "proRataFactor": 1,
      "deductibleBasis": null,
      "coPaymentBasis": null,
      "sourceCd": null,
      "claimNum": null,
      "accidentFl": null,
      "dateOfAccident": null,
      "alcoholConsumptionFl": null,
      "deathFl": null,
      "emergencyFl": null,
      "parentPreAuthRefNum": null,
      "benefitPreference": null,
      "causeOfEventCd": null,
      "eventTypeCd": "HOSPITALISATION",
      "claimHistory": null,
      "policy": [
        {
          "parentObject": null,
          "versionId": null,
          "createdDt": 1635234063307,
          "updatedDt": 1635255977793,
          "createdUser": "Swapnil",
          "updatedUser": "changt",
          "baseCompanyCd": "MMS",
          "versionNum": null,
          "workflowStatusCd": null,
          "shareByRegionalOfc": null,
          "policyNum": "H000006",
          "baseProductFamilyCd": "HEALTH",
          "baseProductCd": "SCBPHealthCareRider1",
          "baseProductTypeCd": "CONVENTIONAL",
          "sumInsured": 420000,
          "productPlanOptionCd": null,
          "commencementDt": "2020-03-09T18:30:00.000Z",
          "policyIssueDt": "2020-03-09T18:30:00.000Z",
          "expiryDt": "2021-03-10T18:30:00.000Z",
          "statusCd": "INFORCE",
          "premiumPaid": null,
          "remarks": null,
          "baseAgentId": null,
          "policyAge": 1,
          "policyOwnerId": null,
          "insuredId": null,
          "roomTypeCd": null,
          "deductibleAmt": null,
          "coPayAmt": null,
          "deductiblePercentage": null,
          "coPayPercentage": null,
          "insuredDOB": null,
          "regulatorProductCd": null,
          "regulatorProductVersion": null,
          "premPaidTillDt": null,
          "policyEffectiveDate": "2020-03-09T18:30:00.000Z",
          "lastPremRecdDt": null,
          "reinstatementDt": null,
          "earlyClaimFl": null,
          "policyAgeInMonths": 19,
          "riskCategoryCd": null,
          "policyTypeCd": null,
          "policyAgeInDays": 591,
          "productGroupCd": null,
          "wopCd": null,
          "payoutOptionCd": null,
          "policyAgeInDaysIntimationDt": null,
          "policyAgeIntimationDt": null,
          "externalNum": null,
          "jointLifeFl": null,
          "balanceSumInsured": null,
          "paymentFrequencyCd": null,
          "reinsurerCd": null,
          "memberNum": null,
          "clientNum": null,
          "suspenseAmt": null,
          "loanNum": null,
          "masterPolicyNum": null,
          "planNum": null,
          "propensityScore": null,
          "baseProductVersion": null,
          "planTypeCd": null,
          "policyAmmendmentDt": null,
          "premiumStatusCd": null,
          "uwClass": null,
          "uwTask": null,
          "discountAmt": null,
          "lastPremiumPaidDt": null,
          "premiumDueDt": null,
          "premiumDue": null,
          "gracePeriod": null,
          "payableBenefit": null,
          "groupRiskClass": null,
          "providerCd": null,
          "payableBenefitCd": null,
          "policyStatusAtEventCd": "INFORCE",
          "groupRiskClassCd": null,
          "claimPolicyCoverages": [
            {
              "parentObject": null,
              "versionId": null,
              "createdDt": 1635254566061,
              "updatedDt": 1635255977793,
              "createdUser": "changt",
              "updatedUser": "changt",
              "baseCompanyCd": "MMS",
              "versionNum": null,
              "workflowStatusCd": null,
              "shareByRegionalOfc": null,
              "productCd": "SCBPHealthCareRider1",
              "claimCd": null,
              "benefitGroupCd": null,
              "productVersion": 1,
              "regulatorProductCd": null,
              "regulatorProductVersion": null,
              "role": null,
              "planTypeCd": "BASEPLAN",
              "sumInsured": null,
              "coverageStatusCd": "INFORCE",
              "coverageEffectiveDt": null,
              "coverageExpiryDt": null,
              "coverageDeleteDt": "2024-10-24T18:30:00.000Z",
              "coverageReinstatementDt": null,
              "coverageIssueDt": null,
              "planOptionCd": "BASIC",
              "proRataFactor": null,
              "componentCd": null,
              "coverageSeq": null,
              "lifeSeq": null,
              "roleCd": null,
              "coverageSeqNum": null,
              "lifeSeqNum": null,
              "claimPolicyCovBenefits": [],
              "additionalFields": [],
              "objectName": "PreauthPolicyCoverageDO",
              "baseAdditionalFields": [],
              "referenceNum": null
            }
          ],
          "claimLoggedFl": true,
          "additionalFields": [],
          "objectName": "PreauthorizationPolicyDO",
          "referenceNum": null,
          "baseAdditionalFields": null
        }
      ],
      "claimClients": [
        {
          "parentObject": null,
          "versionId": null,
          "createdDt": 1635234011963,
          "updatedDt": 1635255977793,
          "createdUser": "Swapnil",
          "updatedUser": "changt",
          "baseCompanyCd": "MMS",
          "versionNum": null,
          "workflowStatusCd": null,
          "shareByRegionalOfc": null,
          "memberNum": null,
          "blackListedFl": null,
          "clientNum": null,
          "suspenseAmt": null,
          "loanNum": null,
          "masterPolicyNum": null,
          "planNum": null,
          "empNum": null,
          "dependentNum": null,
          "memberAdditionDt": null,
          "memberStatus": null,
          "objectName": "PreauthorizationClientDO",
          "roleCd": "INSURED",
          "clientRefGuid": "2FCBE256-3CF6-4A0E-A3BE-BCDE7F74E030",
          "relatedToInsuredCd": null,
          "clientCd": null,
          "clientId": null,
          "insuredDOB": "1975-09-01T18:30:00.000Z",
          "paymentFrequencyCd": null,
          "reinsurerCd": null,
          "nomieeSplitPrct": null,
          "appointeeClientRefGuid": null,
          "relatedToBenefCd": null,
          "attainedAge": null,
          "genderCd": null,
          "groupRiskClassCd": null,
          "memberStatusCd": null,
          "familyPhysicianNum": null,
          "attendingRelative": null,
          "referenceNum": null,
          "baseAdditionalFields": null
        }
      ],
      "claimHospitalisations": [
        {
          "parentObject": null,
          "versionId": null,
          "createdDt": 1635234011995,
          "updatedDt": 1635254368654,
          "createdUser": "Swapnil",
          "updatedUser": "changt",
          "baseCompanyCd": "MMS",
          "versionNum": null,
          "workflowStatusCd": null,
          "shareByRegionalOfc": null,
          "providerNum": "PR0000152",
          "packageName": null,
          "packageNum": null,
          "doctorProviderNum": "SP0000650",
          "clinicProviderNum": "SP0001005",
          "anaesthesiaCd": null,
          "providerCountryCd": null,
          "panelNum": null,
          "treatmentTypeCd": null,
          "conditionCdCSV": null,
          "admissionTime": null,
          "dischargeDt": null,
          "dischargeTime": null,
          "noOfDaysInHsptl": null,
          "noOfDaysInHsptlAdjusted": null,
          "noOfDaysInHsptlApproved": null,
          "noOfDaysInICU": null,
          "noOfDaysInICUAdjusted": null,
          "noOfDaysInICUApproved": null,
          "natureOfIllness": null,
          "isConginetal": null,
          "pastHistoryDetails": null,
          "provisionalDiagnosis": null,
          "criticalFindings": null,
          "durationPresentAilment": null,
          "roomTypeCd": "ENDOCSOPY",
          "symptoms": null,
          "signs": null,
          "familyHistory": null,
          "admissionTmDischargeTmDiff": null,
          "providerPinCode": null,
          "icuStartDt": null,
          "icuEndDt": null,
          "gradeSurgery": null,
          "isNetwork": null,
          "hospitalCountryCd": null,
          "hospitalCategoryDepartment": null,
          "singleStandardRoomCharges": null,
          "gradeSurgeryCd": null,
          "isNetworkFl": null,
          "id": null,
          "claimMedicalPCSDetails": [],
          "claimMedicalInvestigations": [],
          "claimMedications": [],
          "additionalFields": [],
          "htlhClmVisitingDoctor": [],
          "objectName": "PreauthorizationHospitalisationDO",
          "baseAdditionalFields": [],
          "network": null,
          "referenceNum": null,
          "approvedAmount": null,
          "totCopay": null,
          "doctorNum": "SP0000650"
        }
      ],
      "claimCoverages": [
        {
          "parentObject": null,
          "versionId": 1,
          "createdDt": 1635234011963,
          "updatedDt": 1635255977793,
          "createdUser": "Swapnil",
          "updatedUser": "changt",
          "baseCompanyCd": "MMS",
          "versionNum": null,
          "workflowStatusCd": null,
          "shareByRegionalOfc": null,
          "productCd": "SCBPHealthCareRider1",
          "claimCd": null,
          "benefitGroupCd": null,
          "productVersion": 1,
          "regulatorProductCd": null,
          "regulatorProductVersion": null,
          "role": null,
          "planTypeCd": "BASEPLAN",
          "sumInsured": 420000,
          "coverageStatusCd": "INFORCE",
          "coverageEffectiveDt": null,
          "coverageExpiryDt": null,
          "coverageDeleteDt": "2024-10-24T18:30:00.000Z",
          "coverageReinstatementDt": null,
          "coverageIssueDt": null,
          "planOptionCd": "BASIC",
          "proRataFactor": null,
          "componentCd": null,
          "coverageSeq": null,
          "lifeSeq": null,
          "roleCd": null,
          "coverageSeqNum": null,
          "lifeSeqNum": null,
          "id": null,
          "claimCoverageBenefits": [],
          "additionalFields": [],
          "objectName": "PreauthorizationCoverageDO",
          "baseAdditionalFields": [],
          "referenceNum": null
        }
      ],
      "claimFIRDetails": null,
      "claimOtherDetails": null,
      "claimOtherPolicies": [],
      "claimEstimatedBillDetails": [],
      "additionalFields": [],
      "objectName": "PreauthorizationDO",
      "referenceNum": "PA0000579",
      "payments": null,
      "baseProductFamilyCd": "HEALTH",
      "medicalConditions": null,
      "numberOfPolicies": 1,
      "numberOfInsureds": 1,
      "insuredClient": {
        "parentObject": null,
        "versionId": null,
        "createdDt": 1635234011963,
        "updatedDt": 1635255977793,
        "createdUser": "Swapnil",
        "updatedUser": "changt",
        "baseCompanyCd": "MMS",
        "versionNum": null,
        "workflowStatusCd": null,
        "shareByRegionalOfc": null,
        "memberNum": null,
        "blackListedFl": null,
        "clientNum": null,
        "suspenseAmt": null,
        "loanNum": null,
        "masterPolicyNum": null,
        "planNum": null,
        "empNum": null,
        "dependentNum": null,
        "memberAdditionDt": null,
        "memberStatus": null,
        "objectName": "PreauthorizationClientDO",
        "roleCd": "INSURED",
        "clientRefGuid": "2FCBE256-3CF6-4A0E-A3BE-BCDE7F74E030",
        "relatedToInsuredCd": null,
        "clientCd": null,
        "clientId": null,
        "insuredDOB": "1975-09-01T18:30:00.000Z",
        "paymentFrequencyCd": null,
        "reinsurerCd": null,
        "nomieeSplitPrct": null,
        "appointeeClientRefGuid": null,
        "relatedToBenefCd": null,
        "attainedAge": null,
        "genderCd": null,
        "groupRiskClassCd": null,
        "memberStatusCd": null,
        "id": 26,
        "familyPhysicianNum": null,
        "attendingRelative": null,
        "referenceNum": null,
        "baseAdditionalFields": null
      },
      "eventTs": "2021-10-21T18:30:00.000Z",
      "intimationTs": "2021-10-22T18:30:00.000Z",
      "taskLevel": null,
      "subStatusCd": null,
      "taskAmt": null,
      "baseAdditionalFields": null,
      "createdDt": 1635234011963,
      "updatedDt": 1635255977793,
      "createdUser": "Swapnil",
      "updatedUser": "changt",
      "baseCompanyCd": "MMS",
      "errorFl": false,
      "warningFl": false,
      "statusCd": "DRAFT",
      "stageCd": "PENDINGPREAUTHDE",
      "effectiveDt": "2021-10-21T18:30:00.000Z",
      "caseManager": "Swapnil",
      "pendingReqFl": false,
      "pendingTaskFl": false,
      "pendingCorresFl": false,
      "pendingChecklistFl": false,
      "DOB": null,
      "hospitalNum": null,
      "communicationDtls": {},
      "providerId": "SP0000650",
      "preAuthType": "PLANNED",
      "preAuthsource": "DOCTOR",
      "submissionModeCd ": "PORTAL"
    },
    "serviceDO": {
      "parentObject": null,
      "versionId": null,
      "guid": null,
      "createdDt": null,
      "updatedDt": null,
      "createdUser": null,
      "updatedUser": null,
      "baseCompanyCd": null,
      "versionNum": null,
      "workflowStatusCd": null,
      "shareByRegionalOfc": null,
      "id": null,
      "service": "PREAUTHORISATION",
      "serviceType": "CheckList",
      "serviceDt": 1634860800000,
      "serviceTaskList": [
        {
          "parentObject": null,
          "versionId": null,
          "guid": null,
          "createdDt": null,
          "updatedDt": null,
          "createdUser": null,
          "updatedUser": null,
          "baseCompanyCd": null,
          "versionNum": null,
          "workflowStatusCd": null,
          "shareByRegionalOfc": null,
          "id": null,
          "serviceTask": "preAuthorisationTask",
          "objectName": "ServiceTaskDO",
          "referenceNum": null,
          "baseAdditionalFields": null
        }
      ],
      "listOfRules": [],
      "callingService": "PREAUTHORIZATION",
      "localeLanguage": "EN",
      "objectName": "ServiceDO",
      "referenceNum": null,
      "baseAdditionalFields": null
    },
    "resultDO": {
      "parentObject": null,
      "versionId": null,
      "guid": null,
      "createdDt": null,
      "updatedDt": null,
      "createdUser": null,
      "updatedUser": null,
      "baseCompanyCd": null,
      "versionNum": null,
      "workflowStatusCd": null,
      "shareByRegionalOfc": null,
      "resultMap": {},
      "objectMapList": [],
      "exceptionList": [],
      "correspondences": [],
      "requirementList": [],
      "autoUWResultList": [],
      "autoAdjResultList": [],
      "questionnaires": [],
      "checkLists": [],
      "id": null,
      "objectName": "ResultDO",
      "referenceNum": null,
      "baseAdditionalFields": null
    }
  }
  
  intimationNum: any;
  getIntimationNum(response){
    if(response && response.intimationDO && response.intimationDO.clmIntimationNum){
     this.intimationNum = response.intimationDO.clmIntimationNum;
    //  this.message.success('Intimation has been submitted' + '('+ response.intimationDO.clmIntimationNum +')');
    }
  }


}
